import { apolloClient } from '@/services/graphql';
import gql from 'graphql-tag';

export const exportServiceCenter = ({
  productId,
  country,
  customer
}: {
  productId: string;
  country: string;
  customer: string;
}) =>
  apolloClient.query({
    query: gql`
      query($productId: String!, $country: String!, $customer: String!) {
        exportServiceCenter(productId: $productId, country: $country, customer: $customer) {
          _id
          status
          active
        }
      }
    `,
    variables: {
      productId,
      country,
      customer
    }
  });
